export const DEFAULT_GRADIENT =
  'linear-gradient(90deg, #b91616 0.00%,#751212 40.00%,#ffffff 100.00%)'
